import { ButtonHTMLAttributes } from 'react';

import { Tooltip } from 'libs/ui';

import { ActionStyled } from './Action.styles';

interface ActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tooltip: string;
}

export const Action = ({ tooltip, ...props }: ActionProps) => (
  <Tooltip title={tooltip}>
    <ActionStyled {...props} />
  </Tooltip>
);
